import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=8cead63a&scoped=true&"
import script from "./Life.vue?vue&type=script&lang=js&"
export * from "./Life.vue?vue&type=script&lang=js&"
import style0 from "./Life.vue?vue&type=style&index=0&id=8cead63a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cead63a",
  null
  
)

export default component.exports